"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styles_1 = __importDefault(require("./styles"));
const react_native_1 = require("react-native");
const scale_1 = require("../../../utils/scale");
const HashtagItem_1 = __importDefault(require("../components/HashtagItem"));
const User_1 = __importDefault(require("../../../networking/apis/User"));
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const skeletons_1 = require("../../../components/skeletons");
const ListHashtagScreen = (props) => {
    const { type } = props?.route?.params;
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [page, setPage] = (0, react_1.useState)(1);
    const [reloadPage, setReloadPage] = (0, react_1.useState)(false);
    const [dataCallApi, setDataCallApi] = (0, react_1.useState)([]);
    const [listData, setListData] = (0, react_1.useState)([]);
    const [checkLoadMore, setCheckLoadMore] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        callApi(1);
    }, []);
    const callApi = async (data) => {
        try {
            const res = await User_1.default.hashtagSearch({ page: data, type: type });
            setDataCallApi(res.data.data);
        }
        catch (error) {
            // setReloadPage(false);
        }
        finally {
        }
    };
    (0, react_1.useEffect)(() => {
        let data = [];
        if (reloadPage == false) {
            if (dataCallApi) {
                data = listData.concat(dataCallApi);
                setListData(data);
                setTimeout(() => {
                    setLoading(false);
                }, 1000);
                setCheckLoadMore(false);
            }
        }
        else {
            if (dataCallApi) {
                data = dataCallApi;
                setListData(data);
                setReloadPage(false);
                setTimeout(() => {
                    setLoading(false);
                }, 1000);
                setCheckLoadMore(false);
            }
        }
    }, [dataCallApi]);
    const reloadScreen = () => {
        setReloadPage(true);
        callApi(1);
        setPage(1);
    };
    const handleLoadMore = () => {
        if (!checkLoadMore) {
            if (dataCallApi) {
                if (dataCallApi?.length < 10) {
                    return false;
                }
                else {
                    setPage(page + 1);
                    callApi(page + 1);
                    setCheckLoadMore(true);
                }
            }
        }
        return false;
    };
    const noData = () => {
        switch (+type) {
            case 0:
                return `このハッシュタグは\n使用されていません`;
            case 1:
                return `このハッシュタグは\n記事では使用されていません`;
            case 2:
                return `このハッシュタグは\n自分史では使用されていません`;
            case 3:
                return `このハッシュタグは\nタイムラインでは使用されていません`;
            case 4:
                return `このハッシュタグは\nプロフィール・フォローでは使用されていません`;
        }
    };
    return (react_1.default.createElement(react_native_1.View, { style: styles_1.default.container }, loading ? (react_1.default.createElement(skeletons_1.ArticleSkeleton, null)) : (react_1.default.createElement(react_native_1.FlatList, { contentContainerStyle: {
            marginTop: (0, scale_1.scale)(5),
            paddingBottom: (0, scale_1.scale)(50),
        }, showsVerticalScrollIndicator: false, data: listData, keyExtractor: (item) => item?.hash_tag_id, renderItem: (item) => (react_1.default.createElement(react_native_1.View, { style: {
                borderBottomColor: '#DDDDDD',
                borderBottomWidth: 1,
                width: '100%',
            } },
            react_1.default.createElement(HashtagItem_1.default, { data: item.item, type: type }))), refreshing: reloadPage, onRefresh: reloadScreen, onEndReachedThreshold: 0.1, onEndReached: handleLoadMore, ListEmptyComponent: react_1.default.createElement(react_native_1.View, { style: {
                marginTop: (0, scale_1.scale)(32),
                width: '100%',
                justifyContent: 'center',
            } },
            react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                    fontSize: (0, scale_1.moderateScale)(16),
                    lineHeight: (0, scale_1.moderateScale)(24),
                    textAlign: 'center',
                    color: '#292A33',
                } }, noData())) }))));
};
exports.default = ListHashtagScreen;
